import React, { useState, useContext } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { toast } from 'react-toastify';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import modalStyles from "./ModalStyles.module.css";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import datePickerStyles from "components/Content/Modal/DatePickerStyles.module.css";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { apiPost } from "app/Services/ApiService";
import { apiUrls } from 'common/ApiUrls';
import moment from "moment";

function EmployeeBulkActionModal({ isOpen, closeModal, dataNames, bulkType, reloadEmployees}) {
  const { companyId } = useContext(PrivateRoutesContext);
  
  const [actionDate, handleActionDate] = useState(new Date());
  const [effectiveDate, handleEffectiveDate] = useState(new Date());

  const [communication, setCommunication] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const getEmployeeIds = () => {
    let employeeIds = [];
    dataNames.map((item) => {
      employeeIds.push(item.employeeID);
    });

    return employeeIds;
  }

  const clearUI = () => {
    setCommunication("");
    handleActionDate(new Date());
    handleEffectiveDate(new Date());
    setErrorMessage("");
  }

  const handleClose = () => {
    closeModal(false);
  };

  // TERMINATE EMPLOYEE
  const handleTermData = () => {
    let employeeIds = getEmployeeIds();

    apiPost(apiUrls.terminateEmployee(companyId, moment(actionDate).format("YYYY-MM-DD"), moment(effectiveDate).format("YYYY-MM-DD")), [...employeeIds])
      .then((res) => {
        // console.log("term employee");
        clearUI();
        closeModal(false);
        toast.success("Termination completed successfully.");
        reloadEmployees && reloadEmployees();
      })
      .catch(error => {
        const backendMessage = typeof error?.response?.data === "string"
          ? error.response.data
          : error?.response?.data?.message;
        setErrorMessage(backendMessage || "Termination Action Unsuccessful, Please Try Again...");
      });
  };

  // REHIRE DATA POST API
  const handleRehireData = () => {
    let employeeIds = getEmployeeIds();

    // debugger
    apiPost(apiUrls.rehireEmployee(companyId, moment(actionDate).format("YYYY-MM-DD"), moment(effectiveDate).format("YYYY-MM-DD")), [...employeeIds])
      .then((res) => {
        // console.log("rehire employee");
        clearUI();
        closeModal(false);
        toast.success("Employee(s) rehired successfully.");
        reloadEmployees && reloadEmployees();
      })
      .catch(error => {
        setErrorMessage("Rehire Action Unsuccessful, Please Try Again...");
        console.log(
          "Rehire Action Unsuccessful, Please Try Again...",
          error
        );
      });
  };

  // RESET PASSWORD POST API
  const handleResetPassword = () => {
    let employeeIds = getEmployeeIds();

    // debugger
    apiPost(apiUrls.employeePasswordReset(companyId), [...employeeIds])
      .then((res) => {
        // console.log("employee password reset");
        clearUI();
        closeModal(false);
      })
      .catch(error => {
        let errorMsg = "Reset Password Action Unseccessful, Please Try Again..."
        setErrorMessage(errorMsg);
        console.log(errorMsg,error);
      });
  };

  // HANDLE UPDATE COMMUNICATION
  const handleUpdateCommunication = (e) => {
    setCommunication(e.target.value);
  };

  const handleSendCommunication = () => {
    let employeeIds = getEmployeeIds();

   //  console.log(`Send communication: ${communication}`);
    
    apiPost(apiUrls.sendCommunication(companyId), { message: communication, employees: employeeIds })
      .then((res) => {
        // console.log("communication sent");
        clearUI();
        closeModal(false);
      })
      .catch(error => {
        setErrorMessage("Send Communication Action Unseccessful, Please Try Again...");
        console.log(
          "Send Communication Action Unseccessful, Please Try Again...",
          error
        );
      });
  };

  const handleClickCancel = () => {
    closeModal(false);
    setErrorMessage("");
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        className={modalStyles.modalWrapper}
        aria-labelledby="responsive-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="responsive-dialog-title">{bulkType}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText> */}
          <TableContainer className="custom-table">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataNames.map((item) => {
                  return (
                    <TableRow key={item.employeeID}>
                      <TableCell>{item.firstName}</TableCell>
                      <TableCell>{item.lastName}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {bulkType === "Termination" || bulkType === "Rehire" ? (
            <div className={modalStyles.datePickerWrapper}>
              <div className={modalStyles.dateWrap}>
                <div className={datePickerStyles.datePickerWrapper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      label={bulkType + " Date"}
                      value={actionDate}
                      onChange={handleActionDate}
                      format="MM/dd/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
              <div className={modalStyles.dateWrap}>
                <div className={datePickerStyles.datePickerWrapper}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      label="Effective Date"
                      value={effectiveDate}
                      onChange={handleEffectiveDate}
                      format="MM/dd/yyyy"
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>
          ) : bulkType === "ResetPassword" ? (
            <></>
          ) : bulkType === "SendCommunication" ? (
            <div>
              <TextField
                multiline
                fullWidth
                margin="normal"
                label="Communication"
                rows={2}
                maxRows={4}
                aria-label="minimum height"
                className={ButtonStyle.feedbackTextarea}
                value={communication}
                onChange={handleUpdateCommunication}
              />
            </div>
          ) : null}
          {/* </DialogContentText> */}
          { errorMessage === "" ? null : <Alert severity="error">{errorMessage}</Alert> }
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          {/* <Link to="/employee"> */}
          <Button
            variant="outlined"
            autoFocus
            className={ButtonStyle.CsubmitBtn}
            onClick={() =>
              bulkType === "Termination"
                ? handleTermData()
                : bulkType === "Rehire"
                ? handleRehireData()
                : bulkType === "ResetPassword"
                ? handleResetPassword()
                : bulkType === "SendCommunication"
                ? handleSendCommunication()
                : null}
          >
            Submit
          </Button>
          {/* </Link> */}
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClickCancel}
            className={ButtonStyle.CcancelBtn}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EmployeeBulkActionModal;
